import type { TrendListResponsePageAllOfThreeContentItem } from './trendListResponsePageAllOfThreeContentItem';

export type TrendListResponsePageAllOfThree = {
  content?: TrendListResponsePageAllOfThreeContentItem[];
};
